import { MDClinician } from "@/Common/Api/MedfarDictionaries/Dto/Responses/MDClinician";
import { Pharmacy } from "@/Common/Api/Pharmacy/Dto/Responses/Pharmacy";
import * as ServerOperations from "@/Common/Operations/operations.server";
import { BaseAction, IRequestExecutionContext, IResponseExecutionContext } from "@/Common/Stores/Actions/BaseAction";

class PatientFaxActions extends BaseAction {
    constructor(onBeforeExecute?: IRequestExecutionContext, onBeforeHandleResponse?: IResponseExecutionContext) {
        super(onBeforeExecute, onBeforeHandleResponse);
    }

    // prescription
    public GeneratePrescriptionPDF(prescriptionId: string, withSignature: boolean = false, pharmacy: Pharmacy): void {
        this.Execute(
            ServerOperations.Server.Myle_Patient_GeneratePrescriptionPDF,
            {
                PrescriptionId: prescriptionId,
                WithSignature: withSignature,
                FaxRxComposite: Pharmacy.getFaxComposite(pharmacy),
                IsForQuebec: sessionStore.getCurrentEmployee().isActiveSiteQuebec(),
                SupervisorContactId: sessionStore.lockedSupervisorContactId
            }
        );
    }

    public SendPrescriptionFax(pharmacy: Pharmacy, prescriptionId: string, setPreferred: boolean = false, printCopy: boolean = false, withSignature: boolean = true): void {
        var requestData = {
            FaxRxComposite: {
                PrescriptionId: prescriptionId,
                SetPrefered: setPreferred,
                PrintCopy: printCopy,
                PharmacyName: pharmacy.Name,
                PharmacyBanner: pharmacy.Banner,
                PharmacyPhone: pharmacy.Phone,
                PharmacyFax: pharmacy.Fax,
                PharmacyAddress: pharmacy.Address,
                WithSignature: withSignature
            }
        };

        this.Execute(ServerOperations.Server.Myle_Faxing_SendRx, requestData);
    }

    // medical note
    public GenerateMedicalNotePDF(patientContactId: string, encounterId: string, withSignature: boolean = false, isPrintingFromApprovedEncounter: boolean = false, apiKeyAndSessionId: string = ""): void {
        var request = {
            PatientContactId: patientContactId,
            EncounterId: encounterId,
            WithSignature: withSignature,
            IsPrintingFromApprovedEncounter: isPrintingFromApprovedEncounter,
            ApiKeyAndSessionId: apiKeyAndSessionId
        };

        this.Execute(ServerOperations.Server.Myle_Patient_MedicalNote_GenerateNotePDF, request);
    }

    public SendMedicalNoteFax(doctor: MDClinician, encounterId: string, patienId: string, pdfFileName: string): void {
        var requestData = {
            FaxMedicalNoteComposite: {
                EncounterId: encounterId,
                PatientId: patienId,
                PdfFileName: pdfFileName,

                DoctorName: doctor.Name,
                DoctorIdentifier: doctor.Identifier,
                DoctorAddress: doctor.Address,
                DoctorPhone: doctor.PhoneNumber,
                DoctorFax: doctor.Fax
            }
        };

        this.Execute(ServerOperations.Server.Myle_Faxing_SendMedicalNote, requestData);
    }
}

export { PatientFaxActions };
